import { LearningPortfolioTextPayloadDto } from './learning-portfolio.dto';

export class LearningPortfolioTextPayload {
    readonly title: string;
    readonly content: string | null;

    constructor(dto: LearningPortfolioTextPayloadDto) {
        this.title = dto.title ?? '';
        this.content = dto.content;
    }
}

export type LearningPortfolioPayload = LearningPortfolioTextPayload;
